export default function appendStyles(root: ShadowRoot) {
    const style = document.createElement('style');

    style.textContent = `
      #collapse-btn {
        display: flex;
        justify-content: flex-end;
        margin: 2px 1px 0 0;
      }
      #collapse-btn img {
        opacity: 0.8;
        cursor: pointer;
        padding: 5px;
      }
      #collapse-btn img:hover {
        opacity: 1.0;
      }
      #collapse-btn.x-collapse img {
        transform: rotate(180deg);
      }
      #logo-wrapper {
        display: flex;
        -webkit-box-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        align-items: center;
        position: relative;
        overflow: hidden;
        margin-top: -3px;
        margin-bottom: 14px;
        width: 100%;
        height: auto;
        min-height: 34px;
      }
      #logo-with-boeing.x-collapse {
        opacity: 0;
      }
      #logo-with-jeppesen.x-collapse {
        opacity: 0;
      }
      #ffmenu-scrolling-wrapper {
        overflow: auto;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .ffmenu-item {
        display: flex;
        align-items: center;
        color: white;
        text-decoration: none;
        padding-left: 9px;
        font-size: 13px;
        min-height: 32px;
        z-index: 1000;
        position: relative;
        margin: 0 4px;
        border-radius: 2px;
        transition: .1s linear padding;
      }
      .ffmenu-item.x-collapse {
        padding-left: 11px;
        margin: 0 5px;
      }
      .ffmenu-item:not(.ffmenu-hover-ignore):hover {
        cursor: pointer;
        background: rgb(64,87,109);
      }
      .ffmenu-item.active {
        background: rgb(52, 152, 219);
      }
      .ffmenu-item.recap {
        margin-bottom: 7px;
      }
      .ffmenu-item.recap.active {
        background: linear-gradient(130.36deg, rgba(161, 75, 246, 0.8) 5.99%, rgba(16, 229, 243, 0.8) 100%);
      }
      .ffmenu-item img {
        margin: -1px 8px 0 0px;
        min-width: 22px;
        width: 22px;
      }
      .ffmenu-item.x-collapse img {
        margin-left: 3px;
      }
      .ffmenu-item span {
        line-height: 1.2;
        font-family: Helvetica Neue, Helvetica, sans-serif;
        padding-right: 8px;
      }
      .ffmenu-item.x-collapse span {
        visibility: hidden;
      }
      
      .ffmenu-item.new-notification::before {
        content: '';
        display: block;
        height: .65em;
        width: .65em;
        font-size: 13px;
        background: red;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: 5px; /* size of bullet */
        transform: translateY(-50%); /* vertical alignment */
        z-index: 1000;    
      }

      .sub-section-header {
        color: #D1D1D6;
        font-size: 10px;
        font-weight: 700;
        line-height: 16px;
        letter-spacing: 1px;
        text-transform: uppercase;
        padding: 0 6px;
        cursor: pointer;
      }
      .sub-section-header img {
        width: 16px;
        height: 10px;
        margin-right: 0;
        transition: 0.3s ease-out transform; /*Rotate chevron when subsection open/closed*/
        transform: rotate(90deg);
      }
      /*When sub section closed/collapsed (less height); rotate caret*/
      .sub-section-header.sub-section-collapse img{
        transform: rotate(0deg);
      }
      .sub-section-contents {
        transition: .3s ease-out height;
      }
      .sub-section-contents.sub-section-collapse {
        height: 0 !important; 
        overflow: hidden;       
      }

      .ffmenu-popup {
        display: none;
        position: absolute;
        padding: 8px 10px;
        z-index: 1000;
        background: #000;
        color: #fff;    
        border-radius: 4px;
        font-size: 13px;
        line-height: 16px;
      }
    
      .ffmenu-popup:before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        position: absolute;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid black;
        left: -8px;
        top: 7px;
      }
      
      .logbook-upsell {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin: 24px 8px;
        padding: 16px;
        border-radius: 4px;
        background-color: rgb(226, 239, 251);
      }
      
      .logbook-upsell.x-collapse {
        display: none;
      }
      
      .logbook-upsell h2 {
        font-size: 14px;
        font-weight: 500;
        color: black;
        margin: 0;
      }
      
      .logbook-upsell p {
        font-size: 12px;
        font-weight: 500;
        white-space: normal;
        line-height: 1.3em;
        max-height: 3.9em;
        overflow-y: hidden;
        color: rgb(66, 72, 83);
        margin: 0;
      }
      
      .logbook-upsell a {
        background-color: rgb(52, 152, 219);
        padding: 8px;
        border-radius: 4px;
        margin: 0;
        text-decoration: none; 
        font-size: 12px;
        font-weight: 400;
        color: white;
        overflow-x: hidden;
        max-width: 100%;
      }
      
      .logbook-upsell a:hover {
        background-color: rgb(62, 162, 229);
      }
    `;

    root.appendChild(style);

    //We add these rules to the host css. These live above the shadow root in the hosting apps css.
    // if the z-index is modified here to be greater than 2000, the z-index for the common modal should be raised too
    // in frontend/scripts/commonV2/components/modal/Modal.tsx
    addStylesToHostDocument(`
        #ffweb-side-menu {
            display: flex; /*apps that dont include common.css need this line*/
            white-space: nowrap;
            flex-direction: column;
            width: 165px;
            min-width: 165px;
            background: #1e374f;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: antialiased; 
            z-index: 2000;
      }
      #ffweb-side-menu.x-collapse {
        flex-basis: 64px;
        width: 64px;
        min-width: 64px;
      }
    `);

    //We want this to be added after the first render. That way when the page is loaded, and is collapsed, there wont
    // be a transition from wide to narrow that is visible.
    // PS these will not be seen the DOM explorer in dev tools, but the browser knows its there and uses it.
    setTimeout(() => {
        addStylesToHostDocument(`
        #ffweb-side-menu {
            transition: 250ms ease-out flex-basis, 250ms ease-out width, 250ms ease-out min-width;
          }
        `);
    });
}

function addStylesToHostDocument(css: string) {
    const docStyles = document.createElement('style');

    document.head.appendChild(docStyles);

    docStyles.setAttribute('type', 'text/css');
    docStyles.appendChild(document.createTextNode(css));
}
